<template>
  <div id="hp-logo">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="1.537 12.366 96.952 74.854"
    >
      <g id="bg">
        <path fill="#FFF" d="M1.537 12.366H97.5V87.22H1.537z" />
      </g>
      <g id="border">
        <path
          d="M1.537 12.366V87.22h96.952V12.366H1.537zm95.024 72.927H3.439v-71h93.098v71h.024z"
        />
      </g>
      <g id="hp">
        <path
          d="M11.488 76.171h2.439v-4.878c0-2.439-1.292-2.439-1.292-4.83 0-1.219.341-1.828.658-2.438h2.439c-.342.61-.659 1.22-.659 2.438 0 2.391 1.292 2.391 1.292 4.83v4.878h2.439v-4.878c0-2.439-1.292-2.439-1.292-4.83 0-2.438 1.292-2.438 1.292-4.828v-4.879h-2.439v4.854h-2.439v-4.854h-2.439v4.879c0 2.39-1.292 2.39-1.292 4.828 0 2.391 1.292 2.391 1.292 4.83v4.878zM25.292 56.78a3.52 3.52 0 00-1.244-.22 3.49 3.49 0 00-1.22.22 3.647 3.647 0 00-2.439 3.439v1.415c0 2.39-1.292 2.39-1.292 4.828 0 2.415 1.292 2.415 1.292 4.854V76.195h2.439v-4.854h2.463v4.854h2.439v-4.879c0-2.438-1.342-2.438-1.342-4.854 0-2.438 1.342-2.438 1.342-4.828V60.22a3.645 3.645 0 00-2.438-3.44zm0 4.855c0 2.39-1.341 2.39-1.341 4.828 0 1.244.366 1.83.683 2.464h-2.439c-.342-.634-.683-1.22-.683-2.464 0-2.438 1.292-2.438 1.292-4.828v-1.221a1.24 1.24 0 011.22-1.219c.683 0 1.244.561 1.244 1.219v1.221h.024zM29.317 61.658c0 2.391-1.292 2.391-1.292 4.83 0 2.39 1.292 2.39 1.292 4.828v4.879h2.439v-4.879c0-2.438-1.292-2.438-1.292-4.828 0-2.439 1.292-2.439 1.292-4.83V56.78h-2.439v4.878zM38.22 57a3.49 3.49 0 00-1.22-.22h-3.683v4.878c0 2.391-1.292 2.391-1.292 4.83 0 2.39 1.292 2.39 1.292 4.828v4.879h2.439v-2.488V71.317c0-2.438-1.292-2.438-1.292-4.828 0-1.22.341-1.83.634-2.439h1c1.024 0 1.244.365 1.049.878-.146.39-.244.878-.244 1.562 0 2.39 1.293 2.39 1.293 4.828v4.879h2.439v-4.879c0-2.438-1.293-2.438-1.293-4.828 0-.464.049-.854.146-1.195.195-.902.61-1.781.073-2.464.463-.366 1.073-1.171 1.073-2.243v-.269c-.049-1.587-1.049-2.856-2.414-3.319zm0 3.414c0 .025-.024.049-.024.074a1.18 1.18 0 01-1.195 1.098h-1.22v-2.391H37c.634 0 1.146.463 1.195 1.098 0 .023.024.023.024.049v.072zM51.244 57a3.49 3.49 0 00-1.22-.22h-3.659v4.878c0 2.391-1.292 2.391-1.292 4.83 0 2.39 1.292 2.39 1.292 4.828v4.879h2.439v-4.879c0-2.438-1.292-2.438-1.292-4.828 0-1.195.292-1.805.634-2.391h1.878c.415 0 .829-.073 1.22-.22a3.647 3.647 0 002.439-3.438A3.623 3.623 0 0051.244 57zm-1.22 4.658h-1.22V59.22h1.22c.659 0 1.22.561 1.22 1.22 0 .658-.537 1.218-1.22 1.218zM60.171 56.78a3.529 3.529 0 00-1.244-.22 3.49 3.49 0 00-1.22.22 3.649 3.649 0 00-2.439 3.439v1.415c0 2.39-1.292 2.39-1.292 4.828 0 2.415 1.292 2.415 1.292 4.854V76.195h2.439v-4.854h2.464v4.854h2.438v-4.879c0-2.438-1.342-2.438-1.342-4.854 0-2.438 1.342-2.438 1.342-4.828V60.22a3.649 3.649 0 00-2.438-3.44zm0 4.855c0 2.39-1.342 2.39-1.342 4.828 0 1.244.366 1.83.683 2.464h-2.438c-.341-.634-.683-1.22-.683-2.464 0-2.438 1.293-2.438 1.293-4.828v-1.221a1.24 1.24 0 011.219-1.219c.684 0 1.244.561 1.244 1.219v1.221h.024zM64.195 76.171h2.439v-2.487V71.294c0-2.439-1.293-2.439-1.293-4.83 0-1.219.342-1.828.634-2.438h1c1.024 0 1.244.366 1.049.878-.146.391-.244.878-.244 1.561 0 2.391 1.293 2.391 1.293 4.83v4.878h2.438v-4.878c0-2.439-1.292-2.439-1.292-4.83 0-.463.049-.854.146-1.194.195-.903.61-1.78.074-2.464a2.94 2.94 0 001.072-2.244v-.267a3.568 3.568 0 00-2.414-3.293 3.49 3.49 0 00-1.22-.22h-3.683v4.878c0 2.391-1.293 2.391-1.293 4.83 0 2.39 1.293 2.39 1.293 4.828v4.852zm2.463-16.951h1.22a1.18 1.18 0 011.195 1.097c0 .025.024.025.024.049v.025c0 .023-.024.049-.024.072a1.18 1.18 0 01-1.195 1.098h-1.22V59.22zM72.049 59.22h2.439v2.438c0 2.391-1.293 2.391-1.293 4.83 0 2.39 1.293 2.39 1.293 4.828v4.879h2.438v-4.879c0-2.438-1.292-2.438-1.292-4.828 0-2.439 1.292-2.439 1.292-4.83V59.22h2.438v-2.44h-7.316v2.44zM85.22 60.365c0 .684-.562 1.221-1.22 1.221s-1.22-.537-1.22-1.221v-3.609h-2.438v3.609c0 2.049.658 2.781 1.902 3.464-.366.659-.781 1.269-.781 2.634 0 2.391 1.293 2.391 1.293 4.83v4.878h2.439v-4.878c0-2.439-1.293-2.439-1.293-4.83 0-1.365.391-1.975.781-2.634 1.17-.341 2.365-1.171 2.73-2.194.146-.391.221-.83.221-1.27v-3.609h-2.439v3.609h.025z"
        />
      </g>
      <g id="bleach">
        <path
          fill="none"
          d="M57.391 31.829h-.026l-2.341 10.269h2.367zM19.61 41.78h-2.146l-.488 4.83h2.171c1.195 0 1.39-1.317 1.39-3.122.024-.976-.245-1.708-.927-1.708zM20.22 32.22h-1.756L18 36.732h2.22c1.048 0 1.195-1.269 1.195-2.683-.025-1.293-.439-1.829-1.195-1.829z"
        />
        <path
          fill="none"
          d="M81.829 24.61l-1.024 10.341h2.756l1.025-10.341h4.487l-2.806 28.512H81.78l1-10.171h-2.756l-1 10.171h-4.487l2.805-28.512h4.487zm-16.366 3.195c1.195-3.439 3.098-4.024 4.781-4.024 1.805 0 3.609.634 5.391 1.634l-.928 9.415c-.902-.366-1.683-.561-2.536-.561-1.317 0-2.513.268-3.293 2.268-.39 1-.756 2.951-.756 5.39 0 2.829.707 3.683 2.292 3.683 1.146 0 2.244-.732 3.366-1.244L73 52.512c-2 1.195-4.073 1.439-5.073 1.439-3.171 0-4.61-1.683-4.61-8.268-.024-4.146.805-13.927 2.146-17.878zm-3.536-3.195v28.512h-4.536v-4.146h-3.707l-.903 4.146h-5.048L54.05 24.61h7.877zM39 24.61h10.854l-.878 9.024h-6.268l-.293 3.195h6.269l-.585 6.146H41.83l-.244 2.561h6.268l-.707 7.585h-10.83L39 24.61zm-5.756 0l-1.781 18.731h4.561l-.951 9.781h-9.098l2.708-28.512h4.561zm-18.561.024h8.951c2.537 0 2.707 2.951 2.707 5.268 0 8.073-1.902 9.195-3.805 9.195v.073c1.292.073 2.708.634 2.708 4.902 0 8.39-2.464 9.073-4.317 9.073h-9.098l2.854-28.511z"
        />
        <path
          d="M25.244 44.073c0-4.269-1.439-4.829-2.708-4.902v-.073c1.927 0 3.805-1.122 3.805-9.195 0-2.317-.17-5.268-2.707-5.268h-8.951l-2.854 28.512h9.098c1.829-.025 4.317-.708 4.317-9.074zm-6.098 2.561h-2.171l.488-4.83h2.146c.683 0 .951.708.951 1.708.001 1.805-.219 3.122-1.414 3.122zm1.049-9.902h-2.22l.463-4.512h1.756c.756 0 1.17.561 1.17 1.829.026 1.39-.12 2.683-1.169 2.683zM35.098 53.122l.926-9.781h-4.561l1.781-18.731h-4.561L26 53.122zM47.854 45.537h-6.269l.244-2.561h6.293l.586-6.147h-6.293l.293-3.195H49l.854-9.024H39l-2.708 28.512h10.854zM52.78 53.122l.903-4.146h3.707v4.146h4.536V24.61h-7.878l-6.317 28.512h5.049zm4.585-21.293h.025v10.269h-2.366l2.341-10.269zM67.902 53.951c.976 0 3.073-.244 5.073-1.439l.78-8.146c-1.121.512-2.219 1.244-3.365 1.244-1.586 0-2.293-.83-2.293-3.683 0-2.439.391-4.39.756-5.39.781-2 1.976-2.268 3.293-2.268.854 0 1.634.195 2.537.561l.926-9.415c-1.78-1-3.585-1.634-5.39-1.634-1.659 0-3.562.61-4.78 4.024-1.366 3.951-2.172 13.732-2.172 17.878.026 6.586 1.489 8.268 4.635 8.268zM79.024 53.122l1-10.195h2.756l-1 10.195 4.488-.024 2.805-28.488h-4.487l-1 10.341h-2.757l1-10.341h-4.464l-2.804 28.512z"
        />
      </g>
    </svg>
    <!-- <div id="message-sticker" v-if="message.length > 0" @click="urlStatus">
      <div class="message-inner flex-center">
        <div class="message-content">
          {{ message }}
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  data: () => ({}),

  props: {
    message: {
      type: String,
      default: "Bleach Hair Party"
    },
    status: String
  },

  methods: {
    urlStatus() {
      if (this.status == "pre") {
        window.open(
          "http://chat.bleachlondon.com/?utm_source=VIP-party&utm_medium=splash-page&utm_term=new-sign-ups",
          "_blank"
        )
      } else if (this.status == "broken") {
        window.open(
          "http://bleachlondon.com/?utm_source=VIP-party&utm_medium=splash-page&utm_term=broken-link",
          "_blank"
        )
      } else if (this.status == "ended" || this.status == "cancelled") {
        window.open(
          "http://bleachlondon.com/?utm_source=VIP-party&utm_medium=splash-page&utm_term=complete",
          "_blank"
        )
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$white: #fff;
$purple: #6e3dcb;
$pink: #edd4df;

$break-large: 720px;
$break-mid: 840px;

@keyframes colorchange {
  0% {
    fill: #c2e449;
  }
  20% {
    fill: #6e3dcb;
  }
  40% {
    fill: #e36c7c;
  }
  60% {
    fill: #c2e449;
  }
  80% {
    fill: #6e3dcb;
  }
  100% {
    fill: #c2e449;
  }
}

@-webkit-keyframes colorchange {
  0% {
    fill: #c2e449;
  }
  20% {
    fill: #6e3dcb;
  }
  40% {
    fill: #e36c7c;
  }
  60% {
    fill: #c2e449;
  }
  80% {
    fill: #6e3dcb;
  }
  100% {
    fill: #c2e449;
  }
}

@mixin prefix($property, $value, $prefixes: ()) {
  @each $prefix in $prefixes {
    #{'-' + $prefix + '-' + $property}: $value;
  }
  #{$property}: $value;
}

@mixin linear-gradient($direction, $color-stops...) {
  background: nth(nth($color-stops, 1), 1);
  background: -moz-linear-gradient($direction, $color-stops);
  background: -webkit-linear-gradient($direction, $color-stops);
  background: -ms-linear-gradient($direction, $color-stops);
  background: linear-gradient($direction, $color-stops);
}

//FLEX
.flex-center {
  @include prefix(display, flex, webkit ms);
  @include prefix(align-items, center, webkit ms);
  @include prefix(justify-content, center, webkit ms);
}

#hp-logo {
  position: relative;
  max-width: 380px;
  padding: 0 100px;
  margin: 0 auto;
  cursor: pointer;

  @media screen and (max-width: $break-mid) {
    padding: 0 0px;
    max-width: 350px;
  }

  @media screen and (max-width: 520px) {
    max-width: 200px;
  }

  @media screen and (max-width: $break-mid) and (max-height: 720px) and (orientation: landscape) {
    max-width: 200px;
  }

  svg {
    fill: #000;
    z-index: 2;
    position: relative;
    #hp {
      @include prefix(animation, colorchange 2s infinite, webkit ms);
    }
  }
}

#message-sticker {
  position: absolute;
  top: -25%;
  right: -18%;
  width: 220px;
  height: 220px;
  z-index: 1;

  @include prefix(box-shadow, 4px 12px 14px -4px rgba(0, 0, 0, 0.15));
  @include linear-gradient(15deg, $purple 0%, $pink 60%);
  @include prefix(border-radius, 50%);
  border: 4px solid $white;

  &.waitin,
  &.boakin,
  &.afters {
    cursor: pointer;
  }

  @media screen and (max-width: $break-mid) {
    top: -188px;
    right: -16%;
    width: 220px;
    height: 220px;
    padding-bottom: 0;
  }
  @media screen and (max-width: 520px) {
    right: -39%;
  }

  @media screen and (max-width: $break-mid) and (max-height: 720px) and (orientation: landscape) {
    top: -43px;
    right: -192px;
    width: 200px;
    height: 200px;
    font-size: 14px;
  }
  .message-inner {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    .message-content {
      @include prefix(transform, rotate(15deg), webkit ms);
      padding: 10%;
      text-transform: uppercase;
      line-height: 1.3;
    }
  }
}
</style>
